// Masks the values of URL parameters that carry a credential: the retail security
// token and the captcha pass (searchToken). Used for Bugsnag, breadcrumbs and GTM.
export const redactTokenId = (url: string): string =>
  url.replace(/([?&](?:tokenId|searchToken)=)[^&#]*/g, "$1REDACTED");
